module.exports = __webpack_public_path__ + "static/media/martial-arts-icon.58f10d05.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/martial-arts-icon.svg
// module id = 40
// module chunks = 0